export const includesIgnoreCase = (stringToSearch, stringToFind) => {
  return (String(stringToSearch) || '').toLowerCase().includes((String(stringToFind) || '').toLowerCase());
};

export const compareStrings = (strA, strB) => {
  const upperA = strA.toUpperCase();
  const upperB = strB.toUpperCase();

  if (upperA < upperB) {
    return -1;
  }

  if (upperA > upperB) {
    return 1;
  }

  return 0;
};

export const equalsIgnoreCase = (stringA, stringB) => {
  // Handle null/undefined values safely
  if (stringA == null || stringB == null) {
    return stringA === stringB;
  }
  return stringA.toLowerCase() === stringB.toLowerCase();
};

export const removeStringFromArray = (stringToRemove, stringArray) => {
  return stringArray.filter((string) => !equalsIgnoreCase(stringToRemove, string));
};

export const getInitials = (name) => {
  const splitName = name.split(' ');
  return splitName
    .map((part) => part[0])
    .join('')
    .toUpperCase();
};
